module.exports = __webpack_public_path__ + "img/group-396.57e9631.png";